import classes from 'styles/components/Anniversary/AnniversaryInfo.module.scss';

import Typography from 'components/Typography';

const AnniversaryInfo = () => (
  <>
    <div className={classes.graphicsBox}>
      <div className={classes.mainImageContainer}>
        <div className={classes.mainImageGradient} />
        <div className={classes.mainImage} />
      </div>
    </div>

    <div className={classes.grid}>
      <Typography className={classes.textbox} align="left">
        <b>
          The Hyatt organization was founded in 1977 to make legal services affordable and
          accessible for all Americans.
        </b>{' '}
        It quickly grew into one of the largest law firms in the U.S. In 1981, Hyatt Legal Services
        implemented its first group legal plan, utilizing its attorney offices throughout the
        country to provide legal assistance to plan members.
      </Typography>

      <div className={classes.separator} />

      <Typography className={classes.textbox} align="center">
        <b>
          Our first group legal plan sponsors included American Express, Deere, and PepsiCo,
          companies which continue to include us as part of their employee benefit plans.
        </b>{' '}
        Hyatt Legal Plans was spun off from Hyatt Legal Services in 1990 and was acquired by MetLife
        in 1997.
      </Typography>

      <div className={classes.separator} />

      <Typography className={classes.textbox} align="right">
        <b>Today, MetLife Legal Plans is the nation's largest provider of group legal services.</b>{' '}
        More than 4,000 organizations, including more than 200 Fortune 500® companies feature
        MetLife Legal Plans in their employee benefit offerings. We serve more than five million
        group legal members and their families.
      </Typography>
    </div>
  </>
);

export default AnniversaryInfo;
